import {
  CheckEmailStatusRequest,
  EmailApi,
  EmailStatusResponse,
  RetryVerificationEmailRequest,
  SendVerificationEmailRequest,
  VerifyUserEmailRequest,
} from '@/api/generated/fetch-client';
import { RepositoryException, WithSignal } from '@/types/typings';

export class EmailRepository {
  constructor(private readonly emailApi: EmailApi) {}

  public async sendEmailVerification(
    requestParams: WithSignal<SendVerificationEmailRequest>,
  ): Promise<void> {
    await this.emailApi.sendVerificationEmail(requestParams);
  }

  public async resendEmailVerification(
    requestParams: WithSignal<RetryVerificationEmailRequest>,
  ): Promise<void> {
    await this.emailApi.retryVerificationEmail(requestParams);
  }

  public async checkEmailStatus(
    requestParams: WithSignal<CheckEmailStatusRequest>,
  ): Promise<EmailStatusResponse> {
    const response = await this.emailApi.checkEmailStatus(requestParams);

    if (!response) {
      throw new RepositoryException('repository getCountries error');
    }

    return response;
  }

  public async submitEmail(requestParams: VerifyUserEmailRequest) {
    return await this.emailApi.verifyUserEmail(requestParams);
  }
}
